export interface IAppRule {
	name: AppRuleNames;
	action: AppRuleActions;
}

export enum AppRuleActions {
	read = "GET",
	create = "POST",
	update = "PUT",
	delete = "DELETE",
}

export enum AppRuleNames {
	users = "users",
	officeFolders = "folders",
	officeRoles = "office-roles",
	deedTypes = "deed-types",
	offices = "offices",
	documents = "documents",
	rib = "rib",
	subscriptions = "subscriptions",
	stripe = "stripe",
}
